import { useState } from "react";
import { ChevronDown, ChevronRight, Calculator, Gauge, Activity } from "lucide-react";

const MESogLoad = () => {
  const [openSections, setOpenSections] = useState(false);

  const toggleSection = () => {
    setOpenSections((prev) => !prev);
  };

  const calculations = [
    {
      id: "load-efficiency-calculation",
      title: "Engine Load Calculation",
      description: "Measures engine workload as percentage of maximum capacity",
      formula: "Engine Load = Current Power Output ÷ Maximum Continuous Rating × 100%",
      borderColor: "border-blue-200",
      bgColor: "bg-blue-50",
      textColor: "text-blue-700",
    },
    {
      id: "speed-efficiency-ratio",
      title: "Speed vs Load Correlation",
      description: "Analyzes relationship between vessel speed and engine workload",
      formula: "Efficiency Ratio = Speed Over Ground ÷ Engine Load",
      borderColor: "border-green-200",
      bgColor: "bg-green-50",
      textColor: "text-green-700",
    },
  ];

  const dataFields = [
    {
      name: "Engine Load",
      unit: "percentage (%)",
      description: "Engine workload relative to maximum continuous rating",
    },
    {
      name: "Speed Over Ground (SOG)",
      unit: "knots",
      description: "Vessel's actual speed relative to seabed",
    },
  ];

  return (
    <div>
      <div className="mb-6 border border-gray-300 rounded-lg overflow-hidden">
        <button
          className="flex items-center justify-between w-full p-5 bg-gray-50 hover:bg-gray-100 transition-colors"
          onClick={toggleSection}
        >
          <div className="flex items-center gap-4">
            <div className="p-3 bg-[#faeebe] rounded-lg">
              <Activity className="w-6 h-6 text-[#b7950b]" />
            </div>
            <div className="text-left">
              <h2 className="text-md font-bold text-gray-800">
                Speed vs Engine Load Calculations
              </h2>
              <p className="text-gray-600 text-sm">
                Performance correlation analysis and efficiency metrics
              </p>
            </div>
          </div>
          {openSections ? (
            <ChevronDown className="w-5 h-5 text-gray-500" />
          ) : (
            <ChevronRight className="w-5 h-5 text-gray-500" />
          )}
        </button>

        {openSections && (
          <div className="p-5 bg-white border-t border-gray-200">
            {/* Data Fields */}
            <div className="mb-6">
              <h4 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
                <Gauge className="w-4 h-4" />
                Performance Measurement Fields
              </h4>
              <div className="grid grid-cols-2 gap-4">
                {dataFields.map((field, index) => (
                  <div key={index} className="p-4 border border-gray-200 rounded-lg bg-white">
                    <div className="flex justify-between items-start mb-2">
                      <h5 className="font-medium text-gray-800">{field.name}</h5>
                      <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded">
                        {field.unit}
                      </span>
                    </div>
                    <p className="text-sm text-gray-600 mb-2">{field.description}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-6">
              <h4 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
                <Calculator className="w-4 h-4" />
                Performance Calculations & Formulas
              </h4>
              <div className="grid grid-cols-2 gap-4">
                {calculations.map((calc) => (
                  <div
                    key={calc.id}
                    className={`p-4 rounded-lg border ${calc.borderColor} ${calc.bgColor}`}
                  >
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {calc.title}
                    </h4>

                    <div className="grid grid-cols-1 gap-4">
                      <div className="space-y-2">
                        <div>
                          <p className="text-sm font-medium text-gray-700">Description:</p>
                          <p className="text-sm text-gray-600">{calc.description}</p>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-gray-700">Formula:</p>
                          <p className="text-sm font-semibold bg-white p-2 rounded border">
                            {calc.formula}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MESogLoad;